import * as React from "react";
import { cn } from "@/lib/utils";

export const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("rounded-xl border border-border/70 bg-card shadow-soft", className)} {...props} />
));
Card.displayName = "Card";

export function CardHeader({ className, title, description, action }: { className?: string; title: React.ReactNode; description?: React.ReactNode; action?: React.ReactNode }) {
  return (
    <div className={cn("flex flex-wrap items-start justify-between gap-3 p-5 pb-0 sm:p-6 sm:pb-0", className)}>
      <div className="min-w-0 space-y-1">
        <h3 className="text-lg">{title}</h3>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export const CardBody = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => <div className={cn("p-5 sm:p-6", className)} {...props} />;
